import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface DeleteUserDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userEmail: string;
}

export default function DeleteUserDialog({
  isOpen,
  onClose,
  onConfirm,
  userEmail
}: DeleteUserDialogProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fadeIn">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full transform transition-all animate-scaleIn">
        <div className="p-6">
          <div className="flex flex-col items-center text-center">
            <div className="mb-4 p-3 rounded-full bg-red-50">
              <AlertTriangle className="w-12 h-12 text-red-500" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Delete User Account</h3>
            <p className="text-gray-600">
              Are you sure you want to delete the account for <strong>{userEmail}</strong>? This action cannot be undone and will:
            </p>
            <ul className="mt-4 text-left text-sm text-gray-600 space-y-2">
              <li>• Delete all user data</li>
              <li>• Remove all calendar events</li>
              <li>• Remove all debts and savings records</li>
              <li>• Delete all support tickets</li>
              <li>• Remove subscription records</li>
            </ul>
          </div>

          <div className="mt-6 flex flex-col-reverse sm:flex-row sm:justify-center space-y-3 space-y-reverse sm:space-y-0 sm:space-x-3">
            <button
              onClick={onClose}
              className="w-full sm:w-auto px-6 py-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onConfirm();
                onClose();
              }}
              className="w-full sm:w-auto px-6 py-3 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
            >
              Delete User
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}